//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionCompare(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M11 22L11 20H4H2V18V6V4H4H11L11 2H13V22H11ZM11 6V18H4V6H11ZM14 6H15.75H16.75V4H15.75H14V6ZM19.25 4H18.25V6H19.25H20V6.75V7.75H22V6.75V5V4H21H19.25ZM22 10.25V9.25H20V10.25V13.75V14.75H22V13.75V10.25ZM22 17.25V16.25H20V17.25V18H19.25H18.25V20H19.25H21H22V19V17.25ZM15.75 18H14V20H15.75H16.75V18H15.75Z" fill="currentColor" /></svg>;
}
export default IconActionCompare;